import { Button, Checkbox, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import dayjs from 'dayjs';
import InputNumber from 'components/input-number';

const { Option } = Select;

const VoucherModalDesktop = ({ viewModel }) => {
  const {
    form,
    isModalOpen,
    voucher,
    handleOk,
    handleCancel,
    onFinish,
    copyVoucherCode,
  } = viewModel;

  return (
    <Modal title='Thêm voucher' open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
      <Form
        name='basic'
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete='off'
        form={form}
        layout='vertical'
      >
        <Form.Item name='id' hidden />

        <Form.Item label='Mã' name='code'>
          <Input
            disabled={voucher.id}
            addonAfter={voucher.id ? <Button size='small' onClick={() => copyVoucherCode(voucher.code)}>Copy</Button> : null}
          />
        </Form.Item>

        <Form.Item label='Mô Tả' name='description' rules={[{ message: 'Please input voucher description!' }]}>
          <Input />
        </Form.Item>

        <Form.Item name='type' label='Loại Voucher' rules={[{ required: true }]}>
          <Select>
            <Option value='fixed'>Giảm số tiền cố định</Option>
            <Option value='percentage'>Giảm theo %</Option>
          </Select>
        </Form.Item>

        <Form.Item label='Giá trị' name='value' rules={[{ required: true, message: 'Please input voucher amount!' }]}>
          <InputNumber style={{ width: 300 }} />
        </Form.Item>

        <Form.Item label='Số lần dùng' name='usage_limit' rules={[{ required: true, message: 'Please input voucher usage_limit!' }]}>
          <InputNumber style={{ width: 300 }} showCalculator={false} />
        </Form.Item>

        <Form.Item name={['limit', 'time', 'is_limit']} valuePropName='checked' noStyle>
          <Checkbox>Giới hạn thời gian</Checkbox>
        </Form.Item>

        <Row>
          <Col span={12}>
            <Form.Item
              label='Ngày bắt đầu'
              name={['limit', 'time', 'start']}
              getValueProps={(value) => ({ value: value ? dayjs(value) : '' })}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label='Ngày kết thúc'
              name={['limit', 'time', 'end']}
              getValueProps={(value) => ({ value: value ? dayjs(value) : '' })}
            >
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default VoucherModalDesktop;